import React, {useEffect, useState} from "react";
import PanelHead from "../../../UI/Panel/PanelHead";
import PanelBody from "../../../UI/Panel/PanelBody";
import {Helper} from "../../../tools/Helper";
import {api_Routes} from "../../../tools/api_Routes";
import {useParams} from "react-router-dom";
import {CircularProgress, LinearProgress} from "@mui/material";
import {FormEditPin} from "../../../UI/Advertising/pin/edit";
import {ShowPin} from "../../../UI/Advertising/pin/show";
import {ShowTopResult} from "../../../UI/Advertising/top-result/show";

const ShowTopResultPanel = () => {
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState({
        title: "",
        description: "",
        pin_url: "",
        pin_place: "",
        views: 0,
        search: 0,
        click_on_panel_name: 0,
        click_on_service_name: 0,
        device_percentages: [],
        country_percentages: [],
    });

    const getData = async () => {
        try {
            const {result, response} = await Helper.Get({
                url: `${api_Routes.TopResultAdvertising.GetOne}${id}`,
            });

            if (response) {
                const pinData = response.data[0]
                setData({
                    title: pinData.url || "",
                    description: pinData.description || "",
                    url: pinData.url || "",
                    views: pinData.views || 0,
                    search: pinData.search || 0,
                    click_on_service_name: pinData.click_on_service_name || 0,
                    click_on_panel_name: pinData.click_on_panel_name || 0,
                    device_percentages: pinData.device_percentages || [],
                    country_percentages: pinData.country_percentages || [],
                });
            }
        } catch (error) {
            console.error("Error fetching details:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    return (
        <div>
            <PanelHead
                title={
                    isLoading ? (
                        <div className="flex items-center gap-4">
                            Show Search Result <CircularProgress size={24}/>
                        </div>
                    ) : (
                        <div className="flex items-center justify-between w-full gap-4">
                            <div>Show Search Result: {data?.title}</div>
                        </div>
                    )
                }
            />
            <PanelBody
                content={
                    isLoading ? (
                        <LinearProgress/>
                    ) : (
                        <ShowTopResult data={data} setData={setData}/>
                    )
                }
            />
        </div>
    );
};

export default React.memo(ShowTopResultPanel);
